export class ConfMenuElem {
    public id: number = 0;
    public text: string = "";
    public selected: boolean = false;
}

export enum zone { ownconfig = 0, sharedconfig = 1, afficheranonyme = 2 };

export class DCMenuElem {
    public page: number = 0;
    public activemenu: boolean = false;
    public url: string = "";
    public name: string = "";
    public hidden: boolean = false;
    public submenu: DCMenuElem[] = [];
    public nofollow: boolean = false;
}

export class DCMenuConfig {
    public resume: DCMenuElem[] = [];
    public hardware: DCMenuElem[] = [];
    public software: DCMenuElem[] = [];
    public reseau: DCMenuElem[] = [];
    public services: DCMenuElem[] = [];
}

export enum typemeta { String = 0, Date = 1 };

export class MCMetaData {
    public type: typemeta = typemeta.String;
    public name: string = "";
    public titre: string = "";
    public data: string = "";
    public date!: Date;
}

export enum RenderElemType { balise = 0, page = 1, pdfpage = 2, image = 3, br = 4, groupe = 5, tableau = 6, persoresume = 7, text = 8, pagination = 9, perso = 15, persoend = 16, partition = 17 };
export class ElemConfig {
    public type: RenderElemType = RenderElemType.balise;
    public pagination: PaginationElemConfig | null = null;
    public img: ImgElemConfig | null = null;
    public text: TextElemConfig | null = null;
    public tab: TabElemConfig | null = null;
    public groupe: GroupeElemConfig | null = null;
    public perso: PersoElemConfig | null = null;
    public balise: BaliseElemConfig | null = null;
    public partition: PartitionElemConfig | null = null;
    public page: PageElemConfig | null = null;
}

export class PaginationElemConfig {
    public top: boolean = false;
}

export class ImgElemConfig {
    public url: string = "";
}

export class TextElemConfig {
    public text: string = "";
    public html: boolean = false;
    public cat: string = "";
}

export class TabElemConfig {
    public titre: string = "";
    public activecatname: string = "";
    public configdata: ElemConfig[] = [];
}

export class GroupeElemConfig {
    public titre: string = "";
    public hasgroup: boolean = false;
    public submenu: ElemConfig[] = [];
}

export class PersoElemConfig {
    public id: number = 0;
    public titre: string = "";
    public value: string = "";
}

export class BaliseElemConfig {
    public titre: string = "";
    public value: string = "";
    public idupdate: string = "";
    public color: string = "";
    public url: string = "";
    public img: string = "";
    public html: boolean = false;
    public modname: string = "";
    public state: string = "";
    public date: Date | null = null;
    public datetime: boolean = false;
}

export class PartitionConfig {
    public partitionnum: number = 0;
    public partitionstartoffset: number = 0;
    public partitionsize: number = 0;
    public partitiontypeid: number = 0;
    public partitionsizefree: number = 0;
    public partitionletter: string = "";
    public partitionlabel: string = "";
}

export class PartitionElemConfig {
    public id: number = 0;
    public capacitystr: string = "";
    public capacity: number = 0;
    public partitions: PartitionConfig[] = [];
    public longueurimage: number = 0;
    public largeurimage: number = 0;
}

export class PageElemConfig {
    public page: number = 0;
    public depth: number = 0;
    public title: string = "";
    public matos: ElemConfig[] = [];
}

export class DCConfigurationViewApiModel {
    public m_configtaches: ElemConfig[] = [];
    public menuconfig: DCMenuConfig | null = null;
    public m_metadatalist: MCMetaData[] = [];
    public m_subtitle: string = "";
    public idpageselect: number = 0;
    public idsubpageselect: number = 0;
    public m_catactivename: string = "";
    public m_titlepagecomplet: string = "";
    public depth: number = 0;
}

export class DCBreadcrumbItem {
    public  name: string = "";
    public  url: string = "";
    }

export class DCBreadcrumb {
    public  isltr: boolean = false;
    public items: DCBreadcrumbItem[] = [];
    }

export class ConfigViewApiModel {
    public m_configuration: DCConfigurationViewApiModel | null = null;
    public page: number = 0;
    public mcsearch: string = "";
    public configerrormessage: string = "";
    public configxmlnotexist: boolean = false;
    public confmachines: ConfMenuElem[] = [];
    public m_zone: zone = zone.afficheranonyme;
    public viewbody: string = "";
    public m_idconfiguser: string = "";
    public m_idconfiguserurl: string = "";
    public m_ownconfig: boolean = false;
    public m_titleaux: string = "";
    public m_dateconfigexpiration: Date | null = null;
    public m_breadcrumb: DCBreadcrumb | null = null;
}

export class DCPosConfig {
    public  pagelevel1: number = 0;
    public  pagelevel2: number = 0;
    public  pagelevel3: number = 0;
    public  pagelevel4: number = 0;
    }

export class ConfigViewApiRequest {
    public lang: string = "";
    public idconfiguser: string = "";
    public page: number = 0;
    public details: boolean = false;
    public search: string = "";
}

export class PaginationConfEventPage {
    public i: number=0;
    public j: number=0;
    public idconfiguser: string="";
    public page: number=0;
}

export  class PersoConfigView {
    public  titre: string = "";
    public  contenu: string = "";
    public  idconfig: number = 0;
    public  idmember: number = 0;
    public idnum: number = 0;
    public isedit: boolean = false;
    }

    export  class PersoConfigRequest {
        public  machine: number = 0;
        public rows: PersoConfigView[] = [];
}

export enum ShareConfig_Type { NONE = 0, ALL = 1, USER = 2 };

export class configblobshare{
    public idnum: number = 0;
    public hashid: string = "";
    public hostname: string = "";
    public sharepublishall: boolean = false;
}

export class ShareConfApiViewModel {
    public m_configblob: configblobshare[] = [];
}

export class UsernameRelation {
    public id: number = 0;
    public name: string = "";
}

export class dccore_shareconfiguser {
    public idmember: number = 0;
    public dateshare: Date | null = null;
}


export class ConfigRelation {
    public id: number = 0;
    public configusers: dccore_shareconfiguser[] = [];
}

export class ShareConfApi2ViewModel {
    public m_configblob: configblobshare[] = [];
    public m_usernamedict: UsernameRelation[] = [];
    public m_configdict: ConfigRelation[] = [];
}

export class ShareConfigRequest {
    public  configstoshare: number[] = [];
    public  levelsecu: number = 0;
    public  usertoshare: number = 0;
    public sharetypepublish: ShareConfig_Type = ShareConfig_Type.NONE;
    public lan: string = "";
    public theme: string = "";
}


export class DCConfigurateurElem {
    public  id: string = "";
    public  idprint: string = "";
    public  titre: string = "";
    public  ischecked: boolean = false;
    public  isenabled: boolean = false;
    public  iscomposite: boolean = false;
        }

export class DCConfigurateurModules {
    public  id: string = "";
    public  titre: string = "";
    public  mode: number = 0;
            public  matos: string = "";
    public features: DCConfigurateurElem[] = [];
}

export class DCConfigurateurViewModel
{
    public m_moduleselect: DCConfigurateurModules | null = null;
}

export class DCConfigurateurModule {
    public   id: string = "";
    public featuresid: string[] = [];
    public lang: string = "";

}

export class ForumShareRequest {
    public  titre: string = "";
    public  contenu: string = "";
    public  idconfig: string = "";
}

